import AxiosClient from "../../../services/axios.services";

class ExcelUploadServices {
  saveExcelUpload = (data) =>
    AxiosClient.post("/api/app/EvaluacionCarga360Externa/", data, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new ExcelUploadServices();
